import * as ACTIONS from "./actionTypes";

const initialState = {
  carBrands: [],
};

function carBrandsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_CAR_BRANDS_SUCCESS: {
      return {
        ...state,
        ...{ carBrands: payload.list },
      };
    }
    default:
      return state;
  }
}

export default carBrandsReducer;
